import { CategoryModel } from '@app/models/Category/Category.model';
import { ServiceModel } from '@app/models/Service/Service.model';
import { ServiceGroupModel } from '@app/models/ServiceGroup/ServiceGroup.model';
import { Catalogue } from '@models/Catalogue/Catalogue.interface';
import {
  UPDATE_CATALOGUE,
  ADD_CATEGORY,
  ADD_SERVICE,
  ADD_LEVEL,
  CLEAR_SERVICES,
  CLEAR_LEVELS,
  CLEAR_CATEGORIES,
  UPDATE_LEVELS,
  SET_LAST_OPENED_CATEGORY,
  CatalogueState,
  START_LOADING,
  END_LOADING,
  ADD_GROUP,
  CLEAR_GROUPS,
  SET_BLOCKED,
  SET_ANIMATION_DISABLED,
  ADD_EXPANDED_ELEMENT,
  CLEAR_EXPANDED_ELEMENTS,
  UPDATE_PATHS,
  ADD_PATH,
  SET_IS_POPULAR,
  SET_FROM_ROUTE,
} from './types';

export function addExpandedElement(id: number) {
  return {
    type: ADD_EXPANDED_ELEMENT,
    elementId: id,
  };
}

export function clearExpandedElements() {
  return {
    type: CLEAR_EXPANDED_ELEMENTS,
  };
}

export function setAnimationDisabled(value: boolean) {
  return {
    type: SET_ANIMATION_DISABLED,
    value,
  };
}

export function setBlocked(value: boolean) {
  return {
    type: SET_BLOCKED,
    value,
  };
}

export function startLoading() {
  return {
    type: START_LOADING,
  };
}

export function endLoading() {
  return {
    type: END_LOADING,
  };
}

export function updateCatalogue(catalogue: Catalogue) {
  return {
    type: UPDATE_CATALOGUE,
    payload: catalogue,
  };
}

export function addCategory(category: CategoryModel) {
  return {
    type: ADD_CATEGORY,
    category,
  };
}

export function clearCategories(lockedCategories: number[]) {
  return {
    type: CLEAR_CATEGORIES,
    lockedCategories,
  };
}

export function addService(service: ServiceModel) {
  return {
    type: ADD_SERVICE,
    service,
  };
}

export function addGroup(group: ServiceGroupModel) {
  return {
    type: ADD_GROUP,
    group,
  };
}

export function addLevel(categoryId: number) {
  return {
    type: ADD_LEVEL,
    categoryId,
  };
}

export function updateLevels(levels: number[]) {
  return {
    type: UPDATE_LEVELS,
    levels,
  };
}

export function updatePaths(paths: string[]) {
  return {
    type: UPDATE_PATHS,
    paths,
  };
}

export function addPath(path: string) {
  return {
    type: ADD_PATH,
    path,
  };
}

export function clearGroups() {
  return {
    type: CLEAR_GROUPS,
  };
}

export function clearServices() {
  return {
    type: CLEAR_SERVICES,
  };
}

export function clearLevels() {
  return {
    type: CLEAR_LEVELS,
  };
}

export function setLastOpenedCategory(state: CatalogueState) {
  let lastOpenedCategory;
  // Если у путях 1 значение, то мы в корневом элементе и он по пути не ищется
  if (state.paths.length > 1) {
    let lastCategoryPath = state.paths[state.paths.length - 1];
    lastOpenedCategory = state.categoriesByPath[lastCategoryPath];
    let parent = lastOpenedCategory.parentId
      ? state.categories[lastOpenedCategory.parentId]
      : undefined;
    // Если текущая категория - первый потомок родителя, то она является популярным и мы отображаем её родителя
    if (parent?.children && parent.children[0] === lastOpenedCategory.id) {
      lastOpenedCategory = parent;
    }
  } else {
    let lastCategoryId = state.levels[state.levels.length - 1];
    lastOpenedCategory = state.categories[lastCategoryId];
  }

  return {
    type: SET_LAST_OPENED_CATEGORY,
    lastOpenedCategory,
  };
}

export function initIsPopular(state: CatalogueState) {
  let lastCategoryId = state.levels[state.levels.length - 1];
  let category = state.categories[lastCategoryId];
  let parentCategory = category?.parentId
    ? state.categories[category.parentId]
    : undefined;
  let isPopular =
    (parentCategory?.children &&
      +parentCategory.children[0] === +category.id &&
      category.elementsType === 'services') ||
    category.elementsType === 'mixed'; // mixed есть только у глобальных популярных
  return {
    type: SET_IS_POPULAR,
    isPopular,
  };
}

export function setIsPopular(isPopular: boolean) {
  return {
    type: SET_IS_POPULAR,
    isPopular,
  };
}

export function setFromRoute(from: string) {
  return {
    type: SET_FROM_ROUTE,
    value: from,
  };
}
